module.exports = __webpack_public_path__ + "img/bugoro_03.9fb8c4f2.png";